import { FC } from 'react';

import { SkeletonRepeat } from '@/components/ui/SkeletonRepeat';

export const AppSkeletonLoader: FC = () => {
  return (
    <div className="flex h-screen">
      {/* Sidebar Skeleton */}
      <div className="border-border bg-background w-64 border-r p-4">
        {/* Logo/Brand area */}
        <div className="bg-secondary-emphasis mb-8 h-8 w-32 rounded-sm" />

        {/* Navigation Items */}
        <div className="space-y-4">
          <SkeletonRepeat
            count={4}
            render={() => (
              <div className="flex items-center space-x-3">
                <div className="bg-secondary-emphasis h-5 w-5 rounded-sm" /> {/* Icon */}
                <div className="bg-secondary-emphasis h-4 w-32 rounded-sm" /> {/* Text */}
              </div>
            )}
          />
        </div>
      </div>

      {/* Main Content Skeleton */}
      <div className="flex-1 p-8">
        {/* Main Content */}
        <div className="mx-auto max-w-2xl space-y-6">
          <div className="space-y-4">
            <div className="vh-50 bg-secondary-emphasis w-full rounded-sm" />
            <SkeletonRepeat count={13} render={() => <div className="bg-secondary-emphasis h-4 w-full rounded-sm" />} />
          </div>
        </div>
      </div>
    </div>
  );
};
